import { URL_REPLACEMENT } from '$const';
import { post } from '~services/api/methods';

export async function postDownloadRequestWorkflowAction(action: string, token: string) {
  const url = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/download_request/${action}/${token}`;
  const response = await post(url, {});
  return response;
}
